const styles = theme => ({
  headerTableCell: {
    backgroundColor: 'white',
    fontSize: '16px',
    color: '#002E47',
    textAlign: 'center',
  },
  headerTableCell2: {
    backgroundColor: 'white',
    fontSize: '16px',
    color: '#002E47',
  },
})

export default styles
